import { MODIFY_SPOC_INFO,CLEAR_DISBURSE, MODIFY_SPOC_TOTAL } from "./actions";

const initialState = {
  pageInfo: {
    accName: "",
    bankName: "",
    branchName: "",
    ifscCode: "",
    accNo: "",
    confirmAccNo: "",
    pan: "",
    cheque: "",
    addrProof: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    campus: "",
  },
  total: {
    bank: "",
    spocTotal: "",
  },
};

const DispurseReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODIFY_SPOC_INFO:
      let data = state.pageInfo;
      data[action.data[0]] = action.data[1];
      return {
        ...state,
        pageInfo: { ...data },
      };
    case MODIFY_SPOC_TOTAL:
      if (!state.total) {
        state = {
          ...state,
          total: {
            bank: "",
            spocTotal: "",
          },
        };
      }
      // let data2 = state.total;
      state.total[action.data[0]] = action.data[1];
      return {
        ...state,
        // total: { ...data2 },
      };
      case CLEAR_DISBURSE:
        // let data2 = state.tokens;
        // data2.token = "";
        // data2.refreshToken = "";
        return initialState;
    default:
      return state;
  }
};
export default DispurseReducer;
